import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { PageHeader, Panel, LoadingState, ErrorState } from "@/components/common";
import { Brain, Lock } from "lucide-react";

export default function GTFCenter() {
  const q = useQuery({ queryKey: ["gtf-status"], queryFn: async () => (await api.get("/strategy-engine/gtf")).data });
  if (q.isLoading) return <LoadingState label="Loading GTF engine..." />;
  if (q.isError) return <ErrorState label="GTF engine status unavailable" onRetry={q.refetch} />;
  const d = q.data;
  return (
    <div className="space-y-6" data-testid="gtf-page">
      <PageHeader title="GTF Strategy Center" subtitle="Modular engine ready · rules come only from your frozen rulebook" icon={Brain} demo={false} testId="gtf-header" />
      <div data-testid="gtf-status" className="flex items-start gap-2 rounded-lg border border-amber-500/30 bg-amber-500/5 px-4 py-3 text-xs text-amber-200">
        <Lock className="w-4 h-4 mt-0.5 shrink-0" /> {d.message} Engine runnable: {String(d.runnable)}.
      </div>
      <Panel title={`Rulebook chapters (${d.chapters_expected})`} testId="gtf-chapters">
        <div className="p-4 grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-2 text-xs">
          {d.chapters.map((c) => (
            <div key={c.chapter} data-testid={`gtf-chapter-${c.chapter}`} className="rounded-md border border-[var(--border-subtle)] px-3 py-2">
              <div className="text-slate-300 font-mono">Ch {c.chapter}</div>
              <div className="text-slate-500">{c.title || "awaiting rulebook"}</div>
            </div>))}
        </div>
      </Panel>
      <Panel title="Engine stages (plug-in points, no rules)" testId="gtf-stages">
        <div className="p-4 flex flex-wrap gap-2 text-xs">{d.stages.map((s) => <span key={s} className="rounded border border-[var(--border-subtle)] px-2 py-1 font-mono text-slate-400">{s}</span>)}</div>
      </Panel>
    </div>
  );
}
